import RadioButtonQuest from "../../../../UI/RadioButtonQuest";
import pound from "../../../../../assets/UFC_DC_V1/img/pound.png";

const Question115 = ({ clsName, onSelectAnswer, prevQuestion, btnDisable = false }) => {
  const optionHandle = (e) => {
    onSelectAnswer(e);
  };

  const handleBack = () => {
    prevQuestion("question115");
  };

  return (
    <div className={`swiper-slide slide-up-now ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        Would you also like us to identify other unaffordable
        lending opportunities?
      </h2>
      <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text slide-up-now">
        <div className="mt-2 d-flex align-items-center"></div>
        <div className="mt-1 d-flex align-items-center slide-up-now">
          <div className="me-3">
            <img height="25" src={pound} alt="" />
          </div>
          <div>
            {" "}
            Our Average Refund for Unaffordable credit is
            <strong> £2,200^</strong>
          </div>
        </div>
      </div>
      <ul className="btn-option optinal-items two-options slide-up-now">
        <li>
          <div className="option_but">
            <RadioButtonQuest
              key="q115_1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center endQuest"
              onClick={optionHandle}
              value="320"
              name="question115"
              id="320"
              dataQuestId={115}
              dataAnsId={320}
            />
          </div>
        </li>

        <li>
          <div className="option_but">
            <RadioButtonQuest
              key="q115_2"
              className="radio"
              labelName="No"
              labelClassName="endQuest"
              onClick={optionHandle}
              value="321"
              name="question115"
              id="321"
              dataQuestId={115}
              dataAnsId={321}
            />
          </div>
        </li>
      </ul>
      <div className="mt-2 mb-4 text-center">
        <div>
          {" "}
          <button
            className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
            type="button"
            onClick={handleBack}
            disabled={btnDisable}
          >
            Back
          </button>{" "}
        </div>
      </div>
    </div>
  );
};

export default Question115;
